MemberMiniProfileView = require 'app/scripts/views/member-menu-profile/member-mini-profile-view'

module.exports = class ActivityMemberMenuView extends MemberMiniProfileView
  renderMenu: -> return
